import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=49a47107&scoped=true&lang=html&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=49a47107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a47107",
  null
  
)

export default component.exports